import axios from "../plugins/parseAxios";
export class AreaAPI {
  constructor(props) { }
  static createArea(payload) {
    return axios.post("functions/createArea", {
      marketId: payload.marketId,
      name: payload.name,
      size: parseFloat(payload.size),
      layout: {},
    });
  }

  static getVacancyAreas(payload) {
    return axios.post("functions/getVacancyAreas", {
      marketId: payload.marketId,
    });
  }
  static getAreasByIds(ids) {
    return axios.post("functions/getAreasByIds", {
      ids
    });
  }
  static updateAreaProducts(payload) {
    return axios.post("functions/updateAreaProducts", payload)
  }
  static updateArea(data) {
    return axios.post("functions/updateArea", {
      id: data.id,
      marketId: data.marketId,
      name: data.name,
      latitude: data.latitude,
      longitude: data.longitude,
      size: data.size || data.size === 0 ? parseFloat(data.size) : undefined,
      layout: data.layout,
      order: data.order
    });
  }
  static updateOrderArea(payload) {
    return axios.post("functions/updateOrderArea", payload);
  }
  static removeArea(id) {
    return axios.post("functions/removeArea", {
      id
    });
  }
  static getAvailableAreas(formData) {
    return axios.post("functions/getAvailableAreas", formData)
  }
  static getAvailableArea(formData) {
    return axios.post("functions/getAvailableArea", formData)
  }
  static getBookingAreas(marketId) {
    return axios.post("functions/getBookingAreas", {
      marketId
    });
  }
  static getDialyActiveAreas(marketId) {
    return axios.post("functions/getDialyActiveAreas", {
      marketId
    });
  }
  static getOverallAreas(formData) {
    return axios.post("functions/getOverallAreas", formData);
  }
  static getProjectArea(formData) {
    return axios.post("functions/getProjectArea", formData)
  }
  static projectAreaCount(formData) {
    return axios.post("functions/projectAreaCount", formData)
  }
  static getAreaBookingSummaryByMarket(marketId) {
    return axios.post("functions/getAreaBookingSummaryByMarket", {
      marketId
    });
  }
  static getAreaBookingSummaryByProject(projectId) {
    return axios.post("functions/getAreaBookingSummaryByProject", {
      projectId
    });
  }

  static getInvoiceDueDateSummaryByMarket(marketId) {
    return axios.post("functions/getInvoiceDueDateSummaryByMarket",{
      marketId
    });
  }

  static getInvoiceDueDateSummaryByProject(projectId) {
    return axios.post("functions/getInvoiceDueDateSummaryByProject",{
      projectId
    });
  }
}
